<template>
  <div>
    <div v-if="!toggleForm" >
      <h3 class="text-center m-b-20">{{ $t('login.welcome') }}</h3>
      <alert-box type="danger" v-if="error && error.message">
        {{ error.message }}
      </alert-box>
      <form class="form-horizontal" method="post" @submit.prevent="doLogin2">
        <div class="form-group">
          <input-text
            type="text"
            name="email"
            :value="form.email"
            class="col-xs-12"
            placeholder="Email"
            @input="text => { setField({ key: 'email', value: text }) }"
          />
        </div>
        <div class="form-group">
          <input-text
            type="password"
            name="password"
            :value="form.password"
            placeholder="Password"
            class="col-xs-12"
            @input="text => { setField({ key: 'password', value: text }) }"
          />
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <div class="d-flex no-block align-items-center">
              <div class="ml-auto">
                <a href="javascript:void(0)"
                    @click="() => doForgotPwd(form.email)"
                    class="text-muted">
                    Forgot password?
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <form-button
            type="primary"
            inputType="submit"
            :text="$t('login.sign_in')"
            :loading="loading"
            :block="true"
            :click="() => {}"
            class="btn btn-lg btn-block btn-info btn-rounded"
          />
        </div>
        <div class="form-group">
          <div class="col-sm-12 text-center">
            Sign Up or Login with
          </div>
        </div>
        <div class="social text-center">
            <div class="button-group">
              <a
                href="https://s-beta.vnisys.com/api/oauth2/authorization/google"
                class="waves-effect waves-light btn-rounded btn-googleplus"
              >
                <i aria-hidden="true" class="fab fa-google-plus-g mr-2"></i>
                GOOGLE
              </a>
            </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12 text-center">
            {{ $t('login.none_account') }}
            <router-link
              :to="{ name: 'register' }"
              class="text-info m-l-5"
              aria-expanded="false"
            >
              {{ $t('login.register') }}
            </router-link>
          </div>
        </div>
      </form>
    </div>
    <form v-else class="form-horizontal" method="post" @submit.prevent="doForgotPwd">
      <div class="form-group ">
        <div class="col-xs-12">
          <h3>Recover Password</h3>
          <alert-box type="danger" v-if="error && error.message">
            {{ error.message }}
          </alert-box>
          <p class="text-muted">Enter your Email and instructions will be sent to you! </p>
        </div>
      </div>
      <div class="form-group ">
        <div class="col-xs-12">
          <input-text
            type="text"
            name="forgot-email"
            :value="form.forgotEmail"
            class="col-xs-12"
            placeholder="Email"
            @input="text => { setField({ key: 'forgotEmail', value: text }) }"
            :errors="errorForm.forgotEmail"
          />
        </div>
      </div>
      <div class="form-group text-center m-t-20">
        <div class="col-xs-12">
          <form-button
            type="primary"
            inputType="submit"
            text="Reset"
            :loading="loading"
            :block="true"
            :click="() => {}"
            class="btn btn-lg btn-block btn-rounded"
          />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <div class="d-flex no-block align-items-center">
            <div class="ml-auto">
              <a href="javascript:void(0)"
                 @click="() => doForgotPwd(form.email)"
                 class="text-muted">
                <i class="fas fa-chevron-left m-r-5"></i> Back to login</a>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import InputText from '@/components/Form/InputText';
import FormButton from '@/components/Form/FormButton';
import LinkButton from '@/components/Misc/LinkButton';
import AlertBox from '@/components/Misc/AlertBox';
import webStorage from '@/libs/webStorage';

export default {
  name: 'LoginForm',
  components: {
    InputText,
    FormButton,
    LinkButton,
    AlertBox,
  },
  props: [ 'stayAfter' ],
  computed: {
    ...mapGetters({
      form: 'auth/form',
      loading: 'auth/loading',
      error: 'auth/error',
      errorForm: 'auth/errorForm',
      toggleForm: 'auth/toggleForm',
    }),
  },
  methods: {
    ...mapActions({
      login: 'auth/login',
      login2: 'auth/login2',
      ssoLogin: 'auth/ssoLogin',
      forgotPwd: 'auth/forgotPwd',
      toggleFormAction: 'auth/toggleFormAction',
      setField: 'auth/setField',
    }),
    async doLogin() {
      await this.login();
      this.checkRedirectLogin();
      const url = `${process.env.VUE_APP_API_URL}/stock/codes/search=${encodeURI(input)}`;
    },

    async doLogin2() {
      await this.login2();
      this.checkRedirectLogin();
    },

    async ssoAuth(provider) {
      const auth = this.$auth;
      await this.ssoLogin({ auth, provider });
      this.checkRedirectLogin();
    },

    async doForgotPwd(email) {
      await this.forgotPwd(email);
      // if (!this.stayAfter) {
      //   this.$router.push({ name: 'login' });
      // }
    },

    checkRedirectLogin() {
      // const lastURL = webStorage.get('LAST_URL');
      // if (lastURL && lastURL !== '/login' && lastURL !== '/') {
      //   this.$router.push({ path: lastURL });
      //   webStorage.remove('LAST_URL');
      // } else {
      //   if (!this.stayAfter) {
          this.$router.push({ name: 'index' });
      //   }
      // }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
